export const arrayDifference = (arr1, arr2) => {
     const set1 = new Set(arr1);
     const set2 = new Set(arr2);
 
     const combinedSet = new Set([...set1, ...set2]);
     const differenceArray = Array.from(combinedSet).filter(x => !(set1.has(x) && set2.has(x)));
 
     return differenceArray;
}